import React from 'react';

const TagIcon = ({ width = '17', height = '17', fill = 'none', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    {...props}
  >
    <g opacity="0.5" clipPath="url(#clip0_3446_9148)">
      <path
        d="M1.57812 2.32408C1.57813 2.12598 1.65682 1.936 1.7969 1.79592C1.93697 1.65584 2.12696 1.57715 2.32505 1.57715H8.30049L14.5851 7.86181C14.8652 8.14195 15.0225 8.52185 15.0225 8.91797C15.0225 9.31408 14.8652 9.69399 14.5851 9.97413L9.9751 14.5842C9.69496 14.8642 9.31506 15.0216 8.91894 15.0216C8.52283 15.0216 8.14293 14.8642 7.86279 14.5842L1.57812 8.29951V2.32408Z"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.93596 5.31187C4.83692 5.31187 4.74192 5.27252 4.67189 5.20248C4.60185 5.13245 4.5625 5.03745 4.5625 4.93841C4.5625 4.83936 4.60185 4.74436 4.67189 4.67433C4.74192 4.60429 4.83692 4.56494 4.93596 4.56494"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.9375 5.31187C5.03655 5.31187 5.13154 5.27252 5.20158 5.20248C5.27162 5.13245 5.31096 5.03745 5.31096 4.93841C5.31096 4.83936 5.27162 4.74436 5.20158 4.67433C5.13154 4.60429 5.03655 4.56494 4.9375 4.56494"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3446_9148">
        <rect width="16.5984" height="16.5984" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TagIcon;
